import { FC, useRef } from 'react'

import { observer } from 'mobx-react-lite'

import {
  IRange,
  MaxCalendarMonths,
  useCalendarKyrgyzstan,
} from 'entities/kyrgyzstan'

import { useCalendarFocus } from 'shared/hooks'
import { MonthWrapper } from 'shared/ui/month-wrapper'

import { CalendarTabs } from './components/calendar-tabs'
import s from './styles.module.scss'

interface CalendarKyrgyzstanProps {
  selectedDate?: IRange
  focusDate?: string
  availableDates?: string[]
  maxMonth?: number
  onDateSelect?: (date: IRange) => void
}

export const CalendarKyrgyzstan: FC<CalendarKyrgyzstanProps> = observer(
  ({
    selectedDate,
    focusDate,
    availableDates,
    maxMonth = MaxCalendarMonths,
    onDateSelect,
  }) => {
    const { selected, activeTab, handleDateClick, handleReset } =
      useCalendarKyrgyzstan({
        initialSelectedDate: selectedDate,
        availableDates,
        onDateSelect,
      })

    const tabsRef = useRef<HTMLDivElement>(null)
    const calendarRef = useRef<HTMLDivElement>(null)

    useCalendarFocus(focusDate, {
      headerRef: tabsRef,
      scrollContainerRef: calendarRef,
    })

    return (
      <div className={s.container}>
        <div ref={tabsRef}>
          <CalendarTabs
            checkinDate={selected.startDate}
            checkoutDate={selected.endDate}
            activeTab={activeTab}
            onReset={handleReset}
          />
        </div>

        <div
          ref={calendarRef}
          className={s.calendar}
        >
          <MonthWrapper
            indexDirection={0}
            isDifficult={false}
            selected={selected}
            onClick={handleDateClick}
            maxMonth={maxMonth}
            activeDays={availableDates}
          />
        </div>
      </div>
    )
  },
)
